import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class Test extends React.Component {

    constructor(props) {
        super(props);

        this.userID = this.props.userID;
        this.status = "CREATED";
        this.accessKey = null;

        this.currentQuestionID = null;
        this.currentAnswerIDs = [];

        this.state = {
            accessKey: "",
            errorMessage: "",
            alertMessage: "",
            question: {}
        };
    }

    initQuestion() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + "test/" + this.accessKey + "?USER_ID=" + this.userID + '&Authentication=' + cookie
        ).then((response) => {
            let question = {
                text: response.data.question_text,
                imagePath: response.data.question_img_source,
                answers: []
            };
            if (this.status === "CREATED") {
                this.status = "RUNNING";
                this.props.hideNavbar();
            }
            this.currentQuestionID = response.data.question_id;
            this.currentAnswerIDs = [];
            response.data.answers.forEach((answer) => {
                this.currentAnswerIDs.push(answer.answer_id);
                question.answers.push({
                    text: answer.answer_text,
                    checked: false
                });
            });
            this.setState({
                question: question
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
            if (error.response.data.message === "ERROR:1" && this.status === "CREATED") {
                this.setState({
                    errorMessage: "Sie haben diesen Test bereits abgeschlossen."
                });
            } else if (error.response.data.message === "ERROR:1" && this.status === "RUNNING") {
                this.status = "FINISHED";
                axios.get(Globals.EL_PATH + "test/" + this.accessKey + "/evaluate?USER_ID=" + this.userID + '&Authentication=' + cookie
                ).catch(error => {
                    this.props.CheckAuthError(error);
                });
                this.forceUpdate();
                this.props.showNavbar();
            } else {
                this.setState({
                    errorMessage: error.response.data.message
                });
            }
        });
    }

    nextQuestion() {
        let isChecked = false;

        this.state.question.answers.forEach((answer) => {
            if (answer.checked === true)
                isChecked = true;
        });

        if (isChecked) {
            this.saveQuestion();
        } else {
            this.setState({
                alertMessage: "Sie müssen eine Antwort auswählen!"
            });
        }
    }

    saveQuestion() {
        let answers = [];
        for (let i = 0; i < this.currentAnswerIDs.length; i++) {
            answers.push({
                ANSWER_ID: this.currentAnswerIDs[i],
                IS_CHECKED: this.state.question.answers[i].checked
            });
        }
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.post(Globals.EL_PATH + "test/" + this.accessKey + "?USER_ID=" + this.userID + '&Authentication=' + cookie, {
            QUESTION_ID: this.currentQuestionID,
            ANSWERS: answers
        })
            .then(() => {
                this.initQuestion();
            })
            .catch((error) => {
                this.initQuestion();
                this.props.CheckAuthError(error);
            });
    }

    handleCheckboxChange(index) {
        let question = this.state.question;
        question.answers[index].checked = !question.answers[index].checked;

        this.setState({
            question: question,
            alertMessage: ""
        });
    }

    handleKeyChange(e) {
        this.setState({
            accessKey: e.target.value,
            errorMessage: ""
        });
    }

    getQuestion() {
        return (
            <div className="question margin-top-lg">
                <div className="well">
                    <h4 className="margin-bottom-md text-center">{this.state.question.text}</h4>
                    {(this.state.question.imagePath !== null) ?
                        <img alt="" src={Globals.EL_PATH + this.state.question.imagePath}/> : null}
                    {
                        this.state.question.answers.map((answer, index) => {
                            return (
                                <div className="checkbox">
                                    <label className="checkbox-label">
                                        <input className="customCheckbox" type="checkbox" checked={answer.checked}
                                               onChange={() => this.handleCheckboxChange(index)}/>
                                        <span className="label-text"><b>{answer.text}</b></span>
                                    </label>
                                </div>
                            );
                        })
                    }
                </div>
                {(this.state.alertMessage !== "") ?
                    <div className="alert alert-danger text-center"><b>{this.state.alertMessage}</b></div> : null}
                <button className="btn btn-info center-block margin-top-md" type="button"
                        onClick={() => this.nextQuestion()}>Nächste Frage
                </button>
            </div>
        );
    }

    startTest() {
        this.accessKey = this.state.accessKey;
        this.initQuestion();
    }

    showTestPage() {
        this.status = "CREATED";
        this.accessKey = null;
        this.currentQuestionID = null;
        this.currentAnswerIDs = [];
        this.setState({
            accessKey: "",
            errorMessage: "",
            alertMessage: "",
            question: {}
        });
    }

    renderStatus() {
        if (this.status === "CREATED") {
            return (
                <div className="accesskey-box">
                    <label className="margin-top-sm text-center margin-bottom-sm">Geben Sie den Ihnen mitgeteilten
                        Teilnahmeschlüssel ein, um mit einem Test zu beginnen.</label>
                    <div className="input-group">
                        <span className="input-group-addon"><b>Teilnahmeschlüssel</b></span>
                        <input placeholder="Beispiel: J5DNM31ZE937" type="text" className="form-control"
                               value={this.state.accessKey} onChange={(e) => this.handleKeyChange(e)}/>
                    </div>
                    {(this.state.errorMessage !== "") ?
                        <div className="alert alert-info text-center"><b>{this.state.errorMessage}</b></div> : null}
                    <button type="button" className="btn btn-info center-block margin-top-md"
                            onClick={() => this.startTest()}>Prüfung starten
                    </button>
                </div>
            );
        } else if (this.status === "RUNNING") {
            return this.getQuestion()
        } else if (this.status === "FINISHED") {
            return (
                <div>
                    <h4 className="text-center padding-top-sm">Sie haben die Prüfung beendet. Danke für Ihre
                        Teilnahme.</h4>
                    <button type="button" className="btn btn-info center-block margin-top-md"
                            onClick={() => this.showTestPage()}>Weiter
                    </button>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="container-test">
                <h1 className="text-center test-header-text">Prüfung</h1>
                {this.renderStatus()}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/user/Test.js